const { reduce } = require('lodash');

const categoryLevels = Object.freeze(['department', 'category', 'subcategory']);
const categoryLevelIndexes = Object.freeze(reduce(categoryLevels, (result, key, val) => {
    result[key] = val;
    return result;
}, {}));

module.exports = {
    categoryLevels,
    categoryLevelIndexes,
};



// WEBPACK FOOTER //
// ./src/shop/categories/categories.constants.js